module.exports = __webpack_public_path__ + "static/img/about1.b202527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about1.png
// module id = JmWL
// module chunks = 0